import React from 'react'

import { SlideinWrap, SlideinItem } from 'src/components/slidein/index'

import Link from 'src/components/link/index'
import Image from 'src/components/image/dynamic'
import Date from 'src/components/datetime/date'

import * as styles from './fixed.module.scss'


const Card = ({ data }) => {

    const url = data.custom.type === 'outer' ? data.custom.url : `/article/${data.custom.slug}`

    return (
        <Link to={url} className={styles.card}>
            <SlideinWrap>
                <SlideinItem delay={0} className={styles.thumbnail}>
                    <Image imagePC={data.custom.thumbnailPc} imageSP={data.custom.thumbnailSp} className={styles.fullsize} />
                </SlideinItem>
                <div className={styles.data}>
                    <SlideinItem delay={200} tagName="header" className={styles.head}>
                        <div className={styles.info}>
                            <div className={styles.flex}>
                                <div className={styles.tag}>{data.tags.nodes[0].name}</div>
                                <Date dateText={data.custom.datetime} />
                            </div>
                        </div>
                    </SlideinItem>
                    <SlideinItem delay={300} className={styles.bottom}>
                        <div className={styles.title}>{data.custom.title}</div>
                    </SlideinItem>
                </div>
            </SlideinWrap>
        </Link>
    )
}

export default Card
